import React from "react";
import ModalPickerWithChooseButton from "components/Picker/ModalPickerWithChooseButton";
import HubSpotDealList from "./HubSpotDealList";
import { ModalPickerProps } from "../props";

const HubSpotDealModalPicker = (props: ModalPickerProps<server.dto.HubSpotDeal>) => {

  return <ModalPickerWithChooseButton
    onNewClicked={() => { }}
    buttonLabel={"Link HubSpot deal"}
    modalTitle={"HubSpot deals"}
    modalSize="mini"
    renderModalContent={(closeModal) => <HubSpotDealList
      onItemSelected={(deal) => {
        closeModal();
        props.onChange(deal);
      }}
    />}
    renderRemovable={() => <></>}
    
    {...props}
  />;
};

export default HubSpotDealModalPicker;